export const MOBILE_TYPES = {
  ANDROID: "android",
  IOS: "ios"
};

export default MOBILE_TYPES;
